/**
 * Catalan translation for bootstrap-datepicker
 * J. Garcia <jogaco.en@gmail.com>
 */
(function () {
  Datepicker.locales.ca = {
    days: ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"],
    daysShort: ["dg.",  "dl.", "dt.", "dc.", "dj.", "dv.", "ds."],
    daysMin: ["dg", "dl", "dt", "dc", "dj", "dv", "ds"],
    months: ["gener", "febrer", "març", "abril", "maig", "juny", "juliol", "agost", "setembre", "octubre", "novembre", "desembre"],
    monthsShort: ["gen.", "febr.", "març", "abr.", "maig", "juny", "jul.", "ag.", "set.", "oct.", "nov.", "des."],
    today: "Avui",
    monthsTitle: "Mesos",
    clear: "Esborra",
    weekStart: 1,
    format: "dd/mm/yyyy"
  };
}());
